<template>
  <div :class="$style.page">
    <Header :date="date" :time="time" :class="$style.header" />
    <SectionLoader :active="isSectionLoading" fill :class="$style.board">
      <Board :time="boardTime" />
    </SectionLoader>
    <Footer :class="$style.footer" />
  </div>
</template>

<script>
import Header from "@/components/orders/Header.vue";
import Board from "@/components/orders/Board.vue";
import Footer from "@/components/orders/Footer.vue";
import SectionLoader from "@/components/common/SectionLoader.vue";
import orderPushHandlerMixin from "@/mixins/orderPushHandlerMixin";
import asyncActionMixin from "@/mixins/asyncActionMixin";
import { formatDateRu, formatTime } from "@/utils/date";
export default {
  mixins: [orderPushHandlerMixin, asyncActionMixin],
  name: "OrdersPage",
  components: {
    Header,
    Board,
    Footer,
    SectionLoader,
  },

  data() {
    return {
      date: "",
      time: "",
      boardTime: "",
      timer: null,
      boardTimer: null,
      queueInterval: null,
    };
  },
  mounted() {
    this.tick();
    this.syncBoardTime();
    this.timer = setInterval(() => this.tick(), 15_000);
    this.boardTimer = setInterval(() => this.syncBoardTime(), 5 * 60_000);
    this.$store.dispatch("department/fetchWorkDays");
    this.withSectionLoading(() => this.fetchQueue());
    this.queueInterval = setInterval(() => this.fetchQueue(), 60_000);
  },

  beforeUnmount() {
    clearInterval(this.timer);
    clearInterval(this.boardTimer);
    clearInterval(this.queueInterval);
  },

  methods: {
    getTodayQueueParams() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const day = String(now.getDate()).padStart(2, "0");
      const date = `${year}-${month}-${day}`;

      return {
        planned_at__gte: `${date}T00:00:00`,
        planned_at__lte: `${date}T23:59:59`,
      };
    },
    tick() {
      const now = new Date();
      this.date = formatDateRu(now);
      this.time = formatTime(now);
    },
    syncBoardTime() {
      this.boardTime = formatTime(new Date());
    },
    async fetchQueue() {
      await this.$store.dispatch("orders/fetchQueue", this.getTodayQueueParams());
    },
  },
};
</script>

<style lang="scss" module>
.page {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
  .board {
    flex: 1 1 auto;
    min-height: 0;
    overflow: auto;
    @include scrollbarY;
  }
  .footer {
    flex-shrink: 0;
  }
}
</style>
